import React from 'react';
import { Table, Button, Popconfirm, Card } from 'antd';

const mockRequests = [
  {
    key: '1',
    title: 'React Advanced Training',
    budget: 10000,
    status: 'Pending',
    requester: 'John Doe',
  },
  {
    key: '2',
    title: 'Leadership Skills Workshop',
    budget: 15000,
    status: 'Pending',
    requester: 'Jane Smith',
  },
];

const TrainingRequestValidation = () => {
  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Budget ($)',
      dataIndex: 'budget',
      key: 'budget',
      render: (text) => `$${text}`,
    },
    {
      title: 'Requester',
      dataIndex: 'requester',
      key: 'requester',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text, record) => (
        <div>
          <Popconfirm
            title="Approve this request?"
            onConfirm={() => handleApprove(record.key)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="primary" style={{ marginRight: 10 }}>
              Approve
            </Button>
          </Popconfirm>
          <Popconfirm
            title="Decline this request?"
            onConfirm={() => handleDecline(record.key)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="danger">Decline</Button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  const handleApprove = (key) => {
    console.log(`Request ${key} approved.`);
  };

  const handleDecline = (key) => {
    console.log(`Request ${key} declined.`);
  };

  return <Card>
    <Table columns={columns} dataSource={mockRequests} />
    </Card>;
};

export default TrainingRequestValidation;
